
const VocabRegisterProfessional = {
    'register_title': ['Registro de profesionales', 'Professional registry'],
    'error_incomplete': ['Por favor complete el paso actual antes de continuar.', 'Please complete the current step before proceeding.'],
    'step_qualifications': ['Formación Académica', 'Qualifications'],
    'step_skills': ['Habilidades', 'Skills'],
    'step_hours': ['Horario de Trabajo', 'Working Hours'],
    
  }
  export default VocabRegisterProfessional;
    